var map = {
	"./music-instructions.json": 4569,
	"./music-library-intro2024.json": 4570,
	"./music-library-launch2024.json": 4571,
	"./music-progression.json": 4572,
	"./startSourcesAdvanced.json": 4573,
	"./startSourcesSimple.json": 4574,
	"./startSourcesSimple2.json": 4575,
	"./startSourcesTracks.json": 4576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4340;